// en.js
import enLocale from 'element-ui/lib/locale/lang/en'   //引入element语言包
import UserAnswer from './UserAnswer'
import PublishProject from './PublishProject'
import SetUp from './SetUp'
import Appearance from './Appearance'
import DataRecycling from './DataRecycling'
import Preview from './Preview'
import QuesLibrary from './QuestionnaireLibrary'
import Personal from './Personal'
import Mywallet from './Mywallet'
import Quota from './Quota'

const lang = {
  main:{
    // 问卷列表以及公共部分
    message:"Message",
    display:"Show",
    ok: 'Confirm',
    cancel: 'Cancel',
    ok2: 'Confirm',
    cancel2: 'Cancel',
    Restore: 'Restore',
    delete: 'Delete',
    save: 'Save',
    save1: 'Save',
    pleaseEnterYourPhoneNumber: 'Please Enter Your Phone Number',
    enterOneUserName: 'Please Enter Your USername',
    pleaseInputPassword: 'Please enter your password',
    PleaseEnterValidPhoneNumber: 'Please Enter A Valid Phone Number',
    SMSSentSuccessfully: 'SMS Sent Successfully!',
    MyQuestionnaire: 'My Questionnaire',
    MyExam: 'My Exam',
    QuesLibrary: 'Questionnaire Library',
    ExamQuestionBank: 'Exam Question Bank',
    UserManagement: 'User Management',
    userInformation: 'User Information',
    myDownloads: 'My Download',
    myWallet: 'My Wallet',
    CustomerServiceCenter: 'Customer Service Center',
    liaison: 'Contact',
    advancedSetting: 'Advanced Setting',
    QuestionnaireStatus: 'Questionnaire Status',
    CreationTime: 'Creation Time',
    DeleteTime: 'Deletion Time',
    PleaseEnterContent: 'Please Enter Content',
    recycleBin: 'Recycle Bin',
    title: 'Title',
    type: 'Type',
    state: 'State',
    Editing: 'Editing',
    ConscriptionConcentration: 'Collecting',
    Ended: 'Ended',
    inReview: 'In Review',
    collectData: 'Collect Data',
    time: 'Time',
    operate: 'Operate',
    edit: 'Edit',
    Preview: 'Preview',
    Release: 'Release',
    data: 'Data',
    PublishProject: 'Publish Project',
    PreviewProject: 'Preview Project',
    CopyProject: 'Copy Project',
    wipeData: 'Wipe Data',
    deleteItem: 'Delete Item',
    questionnaire: 'Questionnaire',
    ThereIsCurrentlyNoDataAvailable: 'There is no data available currently',
    PleaseEnterYourLoginPassword: 'Please Enter Your Login Password',
    whole: 'All',
    Completed: 'Completed',
    PleaseSelectAPieceOfData: 'Please Select a Piece of Data',
    DataPreparationIsUnderway: 'Data preparation is underway and is expected to complete in 5 minutes. Go to',
    CanViewProgress: 'to view progress',
    PleaseEnterTheAccountPassword: 'Please Enter Account Password.',
    DoYouWantToClearTheCurrentData: 'Do you want to clear the current data?',
    tip: 'Tip',
    EmptyCanceled: 'Empty canceled',
    CanBeRestored: 'After the current project is deleted, it will be moved to the recycle bin and can be restored.',
    ImportWasSuccessful: 'Import Successful',
    ImportFailed: 'Import Failed, Please Try Again',
    SuccessfullyCopiedProject: 'Project Copied Successfully!',
    ImportQuestionnaire: 'Import Questionnaire',
    DownloadTemplate: 'Download Template',
    DownloadToLocal: 'Click on Download Template to download the questionnaire template',
    AutomaticallyGenerateQuestionnaires: 'Click on Import Questionnaire to automatically generate the questionnaire',
    ModificationPrompt: 'Modification Prompt',
    QuestionnaireCollected: 'This questionnaire has been collected',
    PausePublishing: 'The modification of the questionnaire may affect the collected data. The publication of the questionnaire will be suspended during modification, and you need to republish it after the modification is completed before continuing to collect data',
    PausePublishingPrompt: 'Pause Publishing Prompt',
    PausePublishingPromptText: 'When you modify the questionnaire, the publication of the questionnaire will be suspended. You need to republish the questionnaire after the modification is completed before continuing with data collection. The original questionnaire link will not be changed.',
    CreateABlankQuestionnaire: 'Create a Questionnaire',
    ReferenceTemplate: 'Reference Template',
    EditItem: 'Edit Item',
    Dataecycling: 'Data Recycling',
    ExitListPage: 'The current questionnaire number is lost, possibly due to clearing the browser cache. The system will exit to the list page.',
    PleaseEnterKeywordSearch: 'Please enter keyword search',
    SearchFor: 'Search',
    // 问卷设计
    export: 'Export',
    import: 'Import',
    useTest: 'Use Test',
    OptionGrouping: 'Option Grouping',
    OptionsToBeGrouped: 'Options to be Grouped',
    GroupedlTips: 'Tip: Please select the option on the left and join the group on the right',
    GroupManagement: 'Group Management',
    AddGroup: 'Add Group',
    join: 'Join',
    GroupName: 'Group Name',
    moveUp: 'Move up',
    MoveDown: 'Down',
    QuestionType: 'Type',
    Appearance: 'Appearance',
    questionBank: 'Question Bank',
    outline: 'Outline',
    copy: 'Copy',
    paste: 'Paste',
    clickQuestionTypeAddQuestion: 'Click on the Question Type to add a question',
    CompleteEditing: 'Complete Editing',
    QuestionSetting: 'Question Setting',
    pageNumber: 'Page Number',
    WholeQuestionSetting: 'Whole Question Setting',
    QuestionMustAnswered: 'This question must be answered',
    ProblemCode: 'Code',
    ProblemCodeHasBeenUsedAndCannotBeReused: 'The problem code has been used and cannot be reused',
    uniqueIdentification: 'Unique identification, example',
    MaximumNumberOfUploadedFiles: 'Maximum Number of Uploaded Files',
    PleaseSelect: 'Please Select',
    DisplayStyle: 'Display Style',
    lowestScore: 'Lowest Score',
    MinimumScoreMustNotBeGreaterThanOrEqualToTheMaximumScore: 'The minimum score must not be greater than or equal to the maximum score',
    highestScore: 'Highest',
    highestScoreMustNotBeLessThanOrEqualToTheLowestScore: 'The highest score must not be less than or equal to the lowest score',
    LogicalSettings: 'Logical Settings',
    AddLogicalPrompts: 'After adding logical settings, respondents can jump to or display different questions based on their answers',
    setUp: 'Set up',
    MutualExclusionInfluence: 'Mutual Exclusion and Influence',
    MutualExclusion: 'Mutual Exclusion',
    Effect: 'Effect',
    AdvancedScripting: 'Advanced Scripting',
    DisplayLineOfIncidenceMatrixQuestion: 'Display Rows for Correlation Matrix Questions',
    SumOfRestrictedSpecificGravity: 'Sum of Restricted Specific Gravity',
    TotalSpecificGravity: 'Total',
    PromptText: 'Prompt Text',
    LeftPromptText: 'Left Text',
    IntermediatePromptText: 'Center Text',
    PromptTextOnTheRight: 'Right Text',
    ManualPositionCorrectionNotAllowed: 'Manual Position Correction Not Allowed',
    InputBoxSize: 'Input Box Size',
    small: 'Small',
    middle: 'Middle',
    big: 'Big',
    QuestionTypeSwitching: 'Type',
    SingleRow: 'Single Row',
    multipleRows: 'MultiLine',
    Radio: 'Radio',
    MultipleChoice: 'Multiple Choice',
    RandomArrangementOfRows: 'Random Arrangement of Rows',
    RandomArrangementOfColumns: 'Random Arrangement of Columns',
    MatrixRowColumnExchange: 'Matrix Row Column Exchange',
    FillingBoxOnTheMobilePhoneCanSlideToAppear: 'The filling box on the mobile phone can slide to appear',
    PagingSettings: 'Paging Settings',
    applyToAll: 'Apply to All',
    MinimumTime: 'Minimum Time',
    MinimumTimeToStayOnThisPage: 'The minimum time to stay on this page',
    EnterSeconds: 'Enter Second',
    second: 'Second',
    MaximumTime: 'Maximum Time',
    PageNeedsToStayForTheLongestTime: 'This page needs to stay for the longest time',
    MoreSettings: 'More Settings',
    PreviousButtonText: 'Previous Button Text',
    NextPageButtonText: 'Next Page Button Text',
    ShowPreviousPagButton: 'Show Previous Page Button',
    OptionalRange: 'Optional Range',
    theLeast: 'Least',
    noLimit: 'No Limit',
    term: 'Term',
    atMost: 'At Most',
    OptionSettings: 'Option Settings',
    subset: 'Subgroup',
    OptionGroupingPrompt: 'When there are multiple options, setting option groups can help respondents answer questions more efficiently.',
    DetailLevel: 'Detailed Level',
    RandomlyArrangeOptions: 'Randomly Arrange Options',
    FixTheLastOption: 'Fix the Last Option',
    LimitSpecificGravityMinimumMaximumValue: 'Limit Specific Gravity Minimum/Maximum Value',
    minimumValue: 'Minimum',
    minimumMustNotBeGreaterThanOrQqualToTheMaximumValue: 'The minimum value must not be greater than or equal to the maximum value',
    MaximumValue: 'Maximum',
    OnlySelect: 'Select Only',
    place: 'Place',
    OptionLayout: 'Option Layout',
    arrange: 'Arrange',
    OptionAssociation: 'Option Association',
    LabelSettings: 'Label Settings',
    tagName: 'Tag Name',
    PleaseEnterALabelName: 'Please Enter a Label Name',
    SettingsFor: 'Settings for',
    AddAFillInBoxAfterTheOption: 'Add a Fill In Box after Option',
    ContentRestrictions: 'Limits',
    WordLimit: 'Word Limit',
    WithinWords: 'Within Words',
    formatLimits: 'Limits',
    FillInAtLeast: 'At Least',
    FillInAtMost: 'At Most',
    DefaultText: 'Default Text',
    ThisBlankCanBeLeftBlank: 'Can be left Blank',
    questionBank: 'Question Bank',
    problem: 'Problem',
    increase: 'Add',
    FillInTheBlankAttribute: 'Fill in the Blank Attribute',
    FillInTheBlankNumber: 'Serial Number',
    WordRange: 'Word Range',
    ThisBlankIsMandatory: 'This blank is mandatory',
    HowManyWordsCanIFillInAatMost: 'How many words can I fill in at most',
    word: 'Word',
    BatchAddOptions: 'Batch Add Options',
    EditTitle: 'Edit Title',
    SetTheQuestion: 'Set Question',
    PleaseSelectAnOption: 'Please Select an Option',
    SelectedItemsAsOptionsForThisQuestion: 'Selected items as options for this question',
    FinishedEditing: 'Editing completed, do you want to publish now?',
    continueEditing: 'Continue Editing',
    PublishNow: 'Publish Now',
    percentage:'Percentage',
    Selected: 'Selected',
    notSelected: 'Not selected',
    show: 'Show',
    NoShow: 'No show',
    numeral: 'Numeral',
    letter: 'Letter',
    Chinese: 'Chinese',
    Email: 'Email',
    cellPhoneNumber: 'Cell Phone number',
    Url: 'Website',
    ID: 'ID Card',
    Item1: '1 Item',
    Item2: '2 Items',
    DetailedToDetailedAddress: "Detailed to 'Detailed Address'",
    DetailedToCity: 'Detailed to "District/County"',
    DetailedTopProvince: "Detailed to 'Province'",
    maximumValueMustNotBeLessThanOrEqualToTheMinimumValue: 'The maximum value must not be less than or equal to the minimum value',
    ReplicatingSuccess: 'Replicating Successful',
    PleaseSelectTheTestQuestionFirst: 'Please Select Test Question First',
    ThereAreCurrentlyNoTestQuestionsToPaste: 'There are currently No Test Questions to Paste',
    CannotBeEmpty: 'Cannot be Empty',
    PleaseSelectAFile: 'Please Select a File',
    fileReadFailure: 'File read failed, please check.',
    maximumValueMustNotExceedTheTotalSpecificGravity: 'The maximum value must not exceed the total specific gravity',
    ImageUploadQuestionDidNotUploadImages: 'Image upload question did not upload images',
    EnterAtLeastOneOption: 'Enter At Least One option!',
    option: 'Option',
    matrix: 'Matrix',
    SuccessfullyAppliedToAll: 'Applied to All Successfully !',
    NoOptionsAvailable: 'No Options Available, Please set!',
    AddedSuccessfully: 'Added Successfully!',
    questionHasAlreadyParticipatedInLogicalSetting: 'This question has already participated in logical settings and cannot be deleted!',
    questionOptionIsAlreadyAssociatedWithAnotherQuestion: 'This question option is already associated with another question and cannot be deleted!',
    firstPageIsTheDefaultPage: 'The first page is the default page and cannot be deleted!',
    operationWillPermanentlyDeleteTheData: 'This operation will permanently delete the data. Do you want to continue?',
    CancelledDeletion: 'Cancelled Deletion',
    other: 'Other',
    PleaseRemoveTheOptionFromTheGroup: 'Please Remove the Option from the Group',
    SuccessfullyDeletedThePption: 'Option Deletion Successful',
    member: 'Member',
    MatrixRow: 'Matrix Row',
    MatrixColumn: 'Matrix Column',
    minimumOptionsCannotExceedTheMaximumOptions: 'The minimum options cannot exceed the maximum options',
    QuestionnaireType: 'Questionnaire Type',
    AssociatedFrom: 'Associated from',
    de: 'and so on',
    Options: 'Options',
    text: 'Text',
    CancelFavorite: 'Cancel Favorite',
    CancelFailed: 'Cancel Failed',
    CollectionSuccessful: 'Collection successful',
    SingleLineInputBox: 'Single Line Input Box',
    MultilineInputBox: 'Multiline Input Box',
    fillInTheBlanks: 'Fill in the Blanks',
    CollectToQuestionBank: 'Collect to Question Bank',
    ThereIsCurrentlyNoQuestionBankAvailable: 'There is currently no question bank available',
    CannotBeEmpty: 'Cannot be Empty',
    create: 'Create',
    CreateANewQuestionBank: 'Create',
    Unclassified: 'Unclassified',
    AddOptions: 'Add Options',
    BatchAdd: 'Batch Add',
    AddOther: 'Add [Other]',
    NewOptions: 'New Options',
    multipleChoice: 'Multiple Choice',
    UploadFailed: 'Upload Failed!',
    EachRowRepresentsOne: 'Each Row Represents One',
    MultipleCanBeAdded: 'Multiple can be added',
    MultipleOptionsCanAdded: 'Each row represents one option and multiple options can be added',
    determine: 'Determine',
    MultipleBlankFilling: 'Multiple Blanks Filling',
    fillInTheBlanks: 'Fill in the Blanks',
    AddAndFillInTheBlank: 'Add and Fill in the Blank',
    dropDown: 'Drop-Down',
    PictureSelection: 'Picture Selection',
    Upload1SheetAtATime: 'Upload 1 Sheet at a Time',
    UpTo10CopiesCanBeUploaded: 'Can upload up to 10 copies',
    modify: 'Modify',
    ValidationFailed: 'Validation Failed',
    CurrentLimitSelection: 'The current limit is to select 3 images. If you need to replace them, please delete the previous image and reselect!',
    StarRating: 'Star Rating',
    score: 'Score',
    ScaleQuestions: 'Scale Questions',
    DateSelection: 'Date Selection',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    SelectDate: 'Select Date',
    SortQuestion: 'Sort Question',
    addressLocation: 'Address/Location',
    ClickToObtainGeographicalLocation: 'Click to Obtain Geographical Location',
    CitySelection: 'City Selection',
    PleaseSelectAProvince: 'Please select a Province',
    PleaseSelectACity: 'Please select a City',
    PleaseSelectADistrictOrCounty: 'Please select a District/County',
    PleaseFillInTheDetailedAddress: 'Please fill in Detailed Address',
    MatrixRadioSelection: 'Matrix Radio Selection',
    addRows: 'Add Row',
    AddColumn: 'Add Column',
    BatchAddRows: 'Batch Add Rows',
    BatchAddColumns: 'Batch Add Columns',
    InsertSpaceFiller: 'Insert Space Filler',
    KeepAtLeastOneOption: 'Keep At Least One Option',
    KeepAtLeastOneSubTopic: 'Keep At Least One Sub-topic!',
    MatrixMultipleSelection: 'Matrix Multiple Selection',
    MatrixStarRating: 'Matrix Star Rating',
    Scoring: 'Scoring',
    MatrixFillingInTheBlank: 'Matrix Filling in the Blank',
    PageNumber: 'Page Number',
    UploadFiles: 'Upload Files',
    ChooseToUploadFilesWithin10M: 'Choose to upload files (within 10M)',
    Timing: 'Timing',
    SelectTime: 'Select time',
    FillInTheBlankHorizontally: 'Fill in the blank horizontally',
    TheLengthDeterminesTheWidthOfFillingInTheBlanks: 'Each blank filling character is 2 Chinese characters wide and which can be input continuously. Its length determines the width of the answer blank. You can use the Delete Key on the keyboard to go back to the content.',
    Range: 'Range',
    CascadeQuestions: 'Cascade Questions',
    EditingOptions: 'Editing Options',
    Query: 'Query',
    SpecificGravityQuestion: 'Specific Gravity Question',
    Proportion: 'Proportion',
    SetColumnProperties: 'Set Column Properties',
    SetRowProperties: 'Set Row Properties',
    CurrentTopic: 'Current Topic',
    ColumnHeader: 'Column Header',
    RowHeader: 'Row Header',
    ValidateProperties: 'Validate Properties',
    MinimumWordCount: 'Minimum Word Count',
    MaximumWordCount: 'Maximum Word Count',
    MultilineText: 'Multiline Text',
    SingleLineText: 'Single Line Text',
    Integer: 'Integer',
    FixedLine: 'Fixed Line',
    DropdownOptions: 'Drop Down Options',
    FileUpload: 'File Upload',
    English: 'English',
    TraditionalChinese: 'Traditional Chinese',
    FirstLevelOptions: 'Primary Options',
    SecondaryOptions: 'Secondary Options',
    ThirdLevelOptions: 'Tertiary Options',
    FourthLevelOption: 'Quaternary Options',
    ThisOptionCannotBeDeleted: 'This Option Cannot Be Deleted',
    ImportOptions: 'Import Options',
    ClickToUpload: 'Click on the File to Upload',
    Download: 'Download',
    BatchAddQuestionTypes: 'Add Question Types in Batch',
    ImportQuestion: 'Import Question',
    PleaseSearchForTagsOrNamesOrQuestioBanks: 'Please search for tags/names/question banks',
    SelfBuiltQuestionBank: 'My',
    Refresh: 'Refresh',
    Quote: 'Quote',
    ThereIsCurrentlyNoContentAvailable: 'There is currently no content available',
    SystemQuestionBank: 'System Question Bank',
    QuestionBankName: 'Question Bank Name',
    TheQuestionBankNameCannotBeEmpty: 'The Question Bank Name Cannot Be Empty',
    Rename: 'Rename',
    DeleteAllQuestionsWithinTheGroup: 'Delete All Questions within the Group',
    DeleteConfirmation: 'Delete Confirmation',
    ScaleSettings: 'Scale Settings',
    ExtremeValueLabel: 'Extreme Value Label',
    CustomContent: 'Custom Content',
    ScaleSetting: 'Scale Setting',
    Level: 'Level',
    StartingValue: 'Starting Value',
    PleaseEnterAValueWithinMax89: 'Please enter a value between -9-89',
    PleaseEnterAValueWithinMax100: 'Please enter a value between -100 and 100',
    PleaseEnterAValueWithinMax10: 'Please enter a value between 1-10',
    Satisfaction: 'Satisfaction',
    Identity: 'Identity',
    Willingness: 'Willingness',
    Importance: 'Importance',
    Conformance: 'Conformance',
    Perception: 'Perception',
    Feasibility: 'Feasibility',
    Custom: 'Custom',
    VeryDissatisfied: 'Very Dissatisfied',
    VerySatisfied: 'Very Satisfied',
    StronglyDisagree: 'Strongly Disagree',
    StronglyAgree: 'Strongly Agree',
    VeryReluctant: 'Very Reluctant',
    VeryWilling: 'Very Willing',
    VeryUnimportant: 'Very Unimportant',
    VeryImportant: 'Very Important',
    VeryInconsistent: 'Very Inconsistent',
    VeryConsistent: 'Very Consistent',
    Senseless: 'Senseless',
    VeryStrong: 'Very Strong',
    Impossible: 'Impossible',
    InAllLikelihood: 'Very Likely',
    ScoreSetting: 'Score Setting',
    ScoreConversionRatioOfThisQuestion: 'Score Conversion Ratio of This Question',
    ClosedLoopOrNot: 'Closed Loop or Not',
    FillingRestrictions: 'Filling Restrictions',
    MinimumMustNotBeGreaterThanOrEqualToMaximum: 'The minimum word count must not be greater than or equal to the maximum word count',
    MaximumMustNotBLessThanOrEqualToMinimum: 'The maximum number of words must not be less than or equal to the minimum number of words',
    JumpLogic: 'Jump logic',
    JumpLogics: 'Jump logics',
    UnconditionalSkipQuestions: 'Unconditionally Skip Questions',
    SkipQuestionsAccordingToConditions: 'Skip Questions According to Conditions',
    AddLogic: 'Add logic',
    AfterAnsweringThisQuestionJumpTo: 'After Answering This Question, Jump to',
    PleaseSelectAQuestion: 'Please Select a Question',
    Provided: 'If',
    StartingScore: 'Starting Score',
    EndScoreScore: 'End Score',
    ThenJumpTo: 'Then Jump To',
    DisplayLogic: 'Display Logic',
    BarDisplayLogic: 'Bar Display Logic',
    DisplayThisQuestionIfTheFollowingConditionsAreMet: 'Display this question if the following conditions are met',
    SetConditionsAndTestQuestionsToBeDisplayed: 'Set conditions and test questions to be displayed',
    Just: 'Just',
    Perhaps: 'Perhaps',
    Arbitrarily: 'Arbitrarily',
    EqualTo: 'Equal to',
    GreaterThan: 'Outweigh',
    LessThan: 'Under',
    Betweenness: 'Betweenness',
    AnyOption: 'Any Option',
    NormalEndIncludedInTheResult: 'Normal End (included in the results)',
    EarlyTerminationDoesNotCountTowardsResults: 'Early end (not included in results)',
    AddConditions: 'Add Conditions',
    When: 'When',
    ThisQuestion: 'This Question',
    PleaseSelectACondition: 'Please Select a Condition',
    ThenDisplay: 'Then Display',
    AddTestQuestions: 'Add Test Questions',
    AddDisplayLogic: 'Add Display Logic',
    NewlyAdded: 'Newly Added',
    Give: 'Give',
    MutualInfluence: 'Mutual Influence',
    Enter: 'Enter',
    Help: 'Help',
    GiveAnExample: 'Give an Example',
    MeetTheFollowingRequirements: 'Meet the Following Requirements',
    ShowThisIssueWhenConditionsAreMet: 'Show this issue when conditions are met',
    NormalCompletion: 'Normal completion',
    ShowWhen: 'Show when',
    PleaseFillOInThisItem: 'Please fill in this item',
    PleaseSelectTheFollowingImage: 'Please select the following image',
    PleaseSelectAnOption: 'Please select an option',
    SelectMultipleOptions: 'Please select the following options (multiple choices)',
    SelectTheFollowingOptions: 'Please select the following options',
    SortTheFollowingOptions: 'Please sort the following options',
    RateTheFollowingItems: 'Please rate the following items',
    FillInTheFollowingInformation: 'Please fill in the following information',
    Headings: 'Heading',
    NextPage: 'Next page',
    LastPage: 'Previous page',
    FullName: 'Full Name',
    Age: 'Age',
    Year: 'Year',
    ContactInformation: 'Contact Information',
    PercentageOfEachItem: 'Please select the percentage of the following items',
    EvaluateThisProject: 'Please evaluate this project',
    FillInMemberInformation: 'Please fill in your team member information',
    Correct: 'Correct',
    Error: 'Error',
    SingleChoice: 'Single Choice',
    MultipleChoiceQuestions: 'Multiple Choice questions',
    TrueOrFalse: 'True or False',
    ParagraphDescription: 'Paragraph Description',
    TextFilling: 'Text Filling',
    QuestionCitation: 'Question Citation',
    SearchForIssueLabelsOrIssueTitles: 'Please search for question tags/question titles',
    BatchReference: 'Batch Reference',
    ProblemLabel: 'Problem Label',
    QuestionTitle: 'Question Title',
    AffiliatedQuestionBank: 'Affiliated Question Bank',
    PersonalTemplate: 'Personal Template',
    SystemTemplate: 'System Template',
    TimeCited: 'Time Cited',
    FilingNumber: '©2026 IMAKE NET SDN. BHD. (1514165-M)',
    Disable: 'Disable'
  },
  ImportQuestion: {
    TextImport: 'Text Import',
    TextEditing: 'Editing',
    ExampleAndHelp: 'Example & Help',
    ClearText: 'Clear Text',
    PasteTheDocumentHere: 'Please copy and paste the prepared document in the sample format here',
    QuestionPreview: 'Question Preview',
    CreateProject: 'Create Project',
    WelcomeMessage: 'Welcome Message',
    PreviewExample: 'Preview Example',
    Example1: 'The emergency number in your country is',
    Example2: 'What scoring methods does SurveyTree support for multiple topic selection?',
    Example3: "The last day of the twelfth lunar month is called New Year's Eve.",
    Example4: 'Who is the author of "Records of the Grand Historian"?',
    Example5: 'Please confirm the answers to the above questions and submit',
    ScoringMethod1: 'Score only when all answers are correct',
    ScoringMethod2: 'You get points for every correctly asnwered question, no points for answering incorrectly',
    ScoringMethod3: 'Each option has a corresponding score',
    Yes: 'Yes',
    No: 'No',
    FormatDescription: 'Format Description',
    FormatDescription1: 'The title of the question should preferably start with a number',
    FormatDescription2: 'It is recommended to add a question type identifier after the question, as the system will automatically identify any questions without identifier',
    FormatDescription3: () =>{
      return `The recognizable question types include:【${lang.ImportQuestion.WelcomeMessage}】、【${lang.main.SingleChoice}】、【${lang.main.MultipleChoiceQuestions}】、【${lang.main.TrueOrFalse}】、【${lang.main.fillInTheBlanks}】、【${lang.main.ParagraphDescription}】；`
    },
    FormatDescription4: 'If unable to recognize correctly, please try adding blank lines between the questions',
    FormatDescription5: 'Do not leave blank lines between options.',
    FormatDescription6: () =>{
      return `Adding words【${lang.main.TextFilling}】after the options of【${lang.main.SingleChoice}】、【${lang.main.MultipleChoiceQuestions}】、【${lang.main.TrueOrFalse}】, a text input box will be added.`
    },
    FormatDescription7: () =>{
      return `Add the words "---JumpToQ4", "---NormalEnd", "---Early Termination"after the options of 【${lang.main.SingleChoice}】,【${lang.main.MultipleChoiceQuestions}】, 【${lang.main.TrueOrFalse}】, or【${lang.main.fillInTheBlanks}】to add jump logic.`
    },
    FormatDescription8: 'Add the words "【ProblemLabel: Label 1】" After the question and add a question label.',
    FormatDescription9: 'Conclusion: The conclusion is divided into',
    ClearPrompt: 'Are you sure to clear the text? After clearing, the entered text cannot be restored',
    ErrorMessage: 'Error Message',
    ProjectTitle: 'Project Title',
    CorrectAnswer: 'Correct Answer',
    Creating: 'Creating',
    CreatedSuccessfully: 'Created Successfully',
    ConclusionNormalEnd: 'Conclusion - Normal Conclusion',
    ConclusionEarlyTermination: 'Conclusion - Early Termination'
  },
  Paper: {
    Title: 'Questionnaire Title',
    Depict: "Thank you for taking a few minutes to participate in this quiz. Let's get started now!",
    endPageNormalMsg: 'You have completed this questionnaire. Thank you for your support',
    endPageAdvanceMsg: 'Sorry, your profile does not suit the survey. Thank you for your participation',
  },
  AdvancedScript: {
    ConditionalFunctionsAndUsage: 'Conditional Function/Usage',
    Normal: 'Ordinary',
    Normal1: '(Single choice, dropdown, image selection, judgment, multiple choice)',
    Normal2: '(scale, star rating)',
    Normal3: '(Matrix Single choice)',
    Normal4: '(Matrix star rating)',
    Normal5: '(Fill in the blank of matrix, matrix combination)',
    Function: 'Function',
    Exist1: 'Multiple selection of existing options',
    Exist2: 'Matrix Multiple Selection Existence Options',
    Exist3: 'Multiple choices do not exist options',
    Exist4: 'Multiple selection matrix Multiple selection does not have an option',
    Include1: 'Multiple selection includes options',
    Include2: 'Matrix Multiple Selection Inclusion Options',
    IsShow: 'Test Question Display',
    IsHide: 'The test question is not displayed',
    IsAnswered: 'The test question has been answered',
    Help: 'Execute Function/Use',
    Help1: 'Matrix Row Display',
    Help2: 'Hide Matrix Rows',
    Help3: 'Test Question Display',
    Help4: 'Hidden Test Questions',
    Help5: 'Assignment',
    Help6: 'Jump To',
    Help7: 'Restore Jump Logic',
    Illustrate: 'Illustrate',
    Illustrate1: 'Test Question Code',
    Illustrate2: 'Line Number',
    Illustrate3: 'Option Number',
    Illustrate4: 'Number of Selected Options',
    Illustrate5: 'And',
    Illustrate6: 'Or'
  },
  login: {
    accountLogin: 'Account Login',
    quickLogin: 'Quick Login',
    userRegistration: 'User Registration',
    changePassword: 'Change Password',
    forgotPassword: 'Forgot Password',
    login: 'Login',
    pleaseEnterTheVerificationCode: 'Please enter the verification code',
    obtainVerificationCode: 'Obtain Verification Code',
    registerNow: 'Register Now',
    returnToLogin: 'Return to Login',
    pleaseEnterNewPassword: 'Please enter a New Password',
    loginWasSuccessful: 'Registration Successful!',
    LoginSucceeded: 'Login Successful!',
    LogOutOfLogin: 'Log out',
  },
  titleEditor: {
    QuoteTheAnswerFromThePreviousQuestion: 'Quote the answer from the previous question',
    introduce: 'Introduce',
    quote: 'Quote',
    CiteTheAnswersToThePreviousQuestionsToTheFollowingText: 'Cite the answers to the previous questions to the following text',
    ThereAreCurrentlyNoTestQuestionsToCite: 'There are currently no test questions to cite',
    PleaseSelectTheTestQuestion: 'Please select the test question',
    QuestionNumber: 'Question number',
    SeniorEditor: 'Senior Editor'
  },
  MyDownloads: {
    FileName: 'File Name',
    FileType: 'File Type',
    Time: 'Time',
    FileSize: 'File Size',
    State: 'State',
    CanDownloaded: 'Can be Downloaded',
    Download: 'Download',
    DataPreparationProgress: 'Data preparation in progress',
    CanDownloaded: 'Can be downloaded',
    ExportException: 'Export Exception',
    DataExpiration: 'Data Expiration'
  },
  ...UserAnswer,
  ...PublishProject,
  ...SetUp,
  ...Appearance,
  ...DataRecycling,
  ...Preview,
  ...QuesLibrary,
  ...Personal,
  ...Mywallet,
  ...Quota,
  ...enLocale
};
export default lang